import { FieldSet } from "@prismicio/editor-ui"
import type { CompositeSliceContent } from "@prismicio/types-internal/lib/content"
import type { CompositeSlice } from "@prismicio/types-internal/lib/customtypes"

import { useSelection } from "../Selection"
import { NonRepeatableZoneEditor } from "../zones/NonRepeatableZoneEditor"
import { RepeatableZoneEditor } from "../zones/RepeatableZoneEditor"

interface CompositeSliceEditorProps {
  id: string
  readOnly: boolean
  compositeSlice: CompositeSlice
  content: CompositeSliceContent
  onContentChange: (content: CompositeSliceContent) => void
  sliceKey?: string
}

export function CompositeSliceEditor(props: CompositeSliceEditorProps) {
  const { compositeSlice, content, onContentChange, sliceKey, id, readOnly } =
    props

  const { selected, selectionId, selection } = useSelection({
    sliceKey
  })

  function onFocus() {
    sliceKey && selection.update("sliceFieldSet", sliceKey)
  }

  return (
    <FieldSet
      id={selectionId}
      selected={selected}
      onFocus={onFocus}
      legend={getLegend(compositeSlice)}
    >
      <NonRepeatableZoneEditor
        id={id}
        readOnly={readOnly}
        nonRepeatableZone={compositeSlice["non-repeat"] ?? {}}
        content={content.nonRepeat}
        onContentChange={(nonRepeatableZoneContent) => {
          onContentChange({ ...content, nonRepeat: nonRepeatableZoneContent })
        }}
      />
      <RepeatableZoneEditor
        id={id}
        readOnly={readOnly}
        repeatableZone={compositeSlice.repeat ?? {}}
        content={content.repeat}
        onContentChange={(repeatableZoneContent) => {
          onContentChange({ ...content, repeat: repeatableZoneContent })
        }}
      />
    </FieldSet>
  )
}

function getLegend(compositeSlice: CompositeSlice): string {
  return (
    compositeSlice.config?.label ??
    compositeSlice.fieldset ??
    compositeSlice.type
  )
}
